import type React from "react";
import { Separator as ShadcnSeparator } from "src/shadcn/components/separator";

const Separator = (props: React.ComponentProps<typeof ShadcnSeparator>) => (
  <ShadcnSeparator {...props} />
);

export { Separator };
